<template>
  <div>
    <!-- 头像裁剪 -->
    <div class="picture">
      <div class="level1 img_box">
        <div class="img_div1">
          <img class="img" :src="imageUrl" alt />
        </div>
        <div class="hide_img">
          <div class="hide_text">
            <el-upload
              :headers="headers"
              class="avatar-uploader"
              action="/resource/File/UploadImg"
              :show-file-list="false"
              :on-change="beforeAvatarUpload"
            >
              <i class="avatar-uploader-icon" style="font-size: 14px">更换头像</i>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :centerBox="option.centerBox"
            :fixedBox="option.fixedBox"
            :fixedNumber="option.fixedNumber"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { VueCropper } from 'vue-cropper';
import * as uploadImg from '@/api/personcenter/index';
export default {
  props: {
    imageUrl: String,
  },
  components: {
    VueCropper,
  },
  data() {
    return {
      // imageUrl: '',
      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 110, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1.4], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        canMove: true,
        isCompress: false, //是否压缩
        compress: 1, //压缩率
      },
      picsList: [], //页面显示的数组
      // 防止重复提交
      loading: false,
      fileinfo: {},
    };
  },
  created() {},
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
  },
  methods: {
    // handleAvatarSuccess(res, file) {
    //   this.imageUrl = URL.createObjectURL(file.raw);
    //   debugger
    //       this.$nextTick(() => {
    //           this.option.img = URL.createObjectURL(file.raw);
    //           this.fileinfo = res
    //           this.dialogVisible = true
    //   })
    // },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        'image/jpg' ||
        'image/webp' ||
        'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('图片格式不正确!(只能包含jpg，png，webp，JPEG)');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      this.fileinfo = file;
      this.$nextTick(() => {
        this.option.img = URL.createObjectURL(file.raw);
        this.dialogVisible = true;
      });
    },

    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        var fileName = this.fileinfo.name;
        this.loading = true;
        //上传阿里云服务器
        //请求
        let formData = new FormData();
        formData.append('publicFile', data); // 文件对象
        formData.append('fileName', fileName);
        // debugger
        uploadImg.UploadPic(formData).then((res) => {
          // debugger
          this.dialogVisible = false;
          this.loading = false;
          this.$emit('chilUpload', res.result);
          this.imageUrl = res.result;
        });
      });
    },
  },
};
</script>
<style>
/deep/.avatar-uploader {
  width: 150px !important;
  height: 210px !important;
}
</style>
<style scoped>
/deep/.picture {
  height: 210px;
  width: 150px;
}
.pictureimg {
  height: 100px;
  width: 100px;
  opacity: 0;
}
.pictureimg:hover {
  height: 100px;
  width: 100px;
  background-color: red;
  opacity: 1;
}
.avatar-uploader .el-upload {
  /* width: 150px;
    height: 210px; */
  border: 1px dashed #ac2828;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  background-color: rgba(247, 165, 165, 0.6);
}
.avatar-uploader-icon {
  display: block;
  color: #ccc;
  width: 75px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  /* opacity: 0; */
}
/* .avatar-uploader-icon:hover {
    display: block;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    background-color: rgba(7, 17, 27, 0.1);
    opacity: 1; 
    
  } */
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
/* .el-icon-plus{
    width:100px;
    height:100px;
  } */
.cropper-content {
  width: 500px;
  height: 500px;
  background: pink;
}
.cropper {
  width: 500px;
  height: 500px;
  background: yellow;
}
.level1 {
  width: 100%;
  text-align: center;
  padding: 20px 0;
  font-weight: bolder;
  font-size: 20px;
  position: relative;
}
.level1.selected_div::after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  height: 71px;
  width: 10px;
  background: rgb(226, 51, 51);
}

.level1.selected_div::before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  height: 71px;
  width: 100%;
  background-color: rgba(247, 165, 165, 0.6);
}
.selected_div {
  color: rgb(226, 51, 51);
}

.img {
  text-align: center;
  width: 150px;
  height: 210px;
  /* border-radius: 50%; */
}
.bg_show {
  box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.1);
  padding-top: 10px;
}
.level1:hover {
  cursor: pointer;
  color: rgb(226, 51, 51);
}
.level1 i {
  font-size: 20px;
  margin-right: 10px;
}
.hide_img {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  color: #fff;
  text-align: center;
  opacity: 0;
}
.hide_img:hover {
  opacity: 1;
}
.img_box {
  position: relative;
  height: 100px;
  line-height: 100px;
}
.img_div1 {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
}
.hide_text {
  width: 150px;
  height: 210px;
  line-height: 210px;
  text-align: center;
  /* border-radius: 50%; */
  background-color: rgba(7, 17, 27, 0.4);
  /* border-radius: 50%; */
  display: inline-block;
}
</style>